/** Reset scroll for restaurant routes (scroll container is usually `.app-content`, not `window`). */
export function scrollRestaurantAppToTop() {
    const scrollRoot = document.querySelector(".app-content");
    if (scrollRoot) {
        scrollRoot.scrollTop = 0;
        scrollRoot.scrollLeft = 0;
    }
    if (typeof window !== "undefined") {
        window.scrollTo(0, 0);
    }
}

/** Run immediately and again after layout/paint (menu → home kept old scroll position). */
export function scrollRestaurantAppToTopAfterNav() {
    scrollRestaurantAppToTop();
    if (typeof window === "undefined") return;
    requestAnimationFrame(() => {
        scrollRestaurantAppToTop();
        requestAnimationFrame(scrollRestaurantAppToTop);
    });
    window.setTimeout(scrollRestaurantAppToTop, 0);
}
